import { render, staticRenderFns } from "./IncidentCategories.vue?vue&type=template&id=5f36565e"
import script from "./IncidentCategories.vue?vue&type=script&lang=js"
export * from "./IncidentCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports